import { withInstall } from '../../../utils/with-install'
import AmbientLight from './AmbientLight.vue'

export const ElAmapLocaAmbientLight = withInstall(AmbientLight)
export default ElAmapLocaAmbientLight
